import { publicFetchJson, publicPostJson } from "./apiHelper";

const VOTER_ID_KEY = "mailinflow_community_voter_id";

/** Anonymous per-browser identity used to dedupe votes server-side (hashed with IP). */
export function getCommunityVoterId() {
  let voterId = localStorage.getItem(VOTER_ID_KEY);
  if (!voterId) {
    voterId =
      window.crypto?.randomUUID?.() ||
      `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(VOTER_ID_KEY, voterId);
  }
  return voterId;
}

export function listFeatureRequests() {
  return publicFetchJson("/community/features");
}

export function submitFeatureRequest({ name, email, title, description, force }) {
  return publicPostJson("/community/features", {
    name,
    email,
    title,
    description,
    voterId: getCommunityVoterId(),
    force: Boolean(force),
  });
}

export function voteFeatureRequest(id) {
  return publicPostJson(`/community/features/${id}/vote`, {
    voterId: getCommunityVoterId(),
  });
}
